(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mystery-mission"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mystery-mission')) {
  customElements.define('mystery-mission', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const buttons = Array.from(this.querySelectorAll('[data-mm-image]'));
      const selectImage = index => {
        const button = buttons[index];
        if (!button) return;
        this.querySelectorAll('.mm-slide').forEach(slide => { slide.hidden = slide.id !== button.getAttribute('aria-controls'); });
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        const position = this.querySelector('[data-mm-position]');
        if (position) position.textContent = `${index + 1} / ${buttons.length}`;
      };
      buttons.forEach((button, index) => button.addEventListener('click', () => selectImage(index)));
      this.querySelectorAll('[data-mm-direction]').forEach(button => {
        button.addEventListener('click', () => {
          const current = buttons.findIndex(item => item.getAttribute('aria-pressed') === 'true');
          selectImage((current + Number(button.dataset.mmDirection) + buttons.length) % buttons.length);
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
